import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'antd'
import { ViewFieldCardWrapper } from './MyProfilePageStyled'

const DEFAULT_COLUMN_PROPS = {
  xs: 24,
  sm: 12,
}

const hasDisplayValue = value => value !== undefined && value !== null && value !== ''

export const ViewFieldCard = memo(({ title, value }) => {
  const hasValue = hasDisplayValue(value)

  return (
    <ViewFieldCardWrapper>
      <div className="profile-field-title">{title}</div>
      <div
        className={
          hasValue ? 'profile-field-value' : 'profile-field-value-empty'
        }>
        {hasValue ? value : 'Chưa cập nhật'}
      </div>
    </ViewFieldCardWrapper>
  )
})

ViewFieldCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.node,
}

const ProfileFieldGrid = ({ fields, columnProps = DEFAULT_COLUMN_PROPS }) => (
  <Row gutter={[16, 16]}>
    {fields.map(field => (
      <Col key={field.title} {...columnProps}>
        <ViewFieldCard title={field.title} value={field.value} />
      </Col>
    ))}
  </Row>
)

ProfileFieldGrid.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      value: PropTypes.node,
    })
  ).isRequired,
  columnProps: PropTypes.shape({
    xs: PropTypes.number,
    sm: PropTypes.number,
    md: PropTypes.number,
    lg: PropTypes.number,
    xl: PropTypes.number,
    xxl: PropTypes.number,
  }),
}

export const ProfileFormGrid = memo(
  ({ fields, columnProps = DEFAULT_COLUMN_PROPS }) => (
    <Row gutter={[16, 16]}>
      {fields.map(field => (
        <Col key={field.key} {...columnProps}>
          {field.content}
        </Col>
      ))}
    </Row>
  )
)

ProfileFormGrid.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired,
    })
  ).isRequired,
  columnProps: PropTypes.shape({
    xs: PropTypes.number,
    sm: PropTypes.number,
    md: PropTypes.number,
    lg: PropTypes.number,
    xl: PropTypes.number,
    xxl: PropTypes.number,
  }),
}

export default memo(ProfileFieldGrid)
